var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pt-8",attrs:{"data-cy":"imprint"}},[_c('a-headline',{attrs:{"large":"","title":_vm.$t('application.imprint.title')}}),_c('div',{staticClass:"pt-8",domProps:{"innerHTML":_vm._s(_vm.imprintText)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }